<template>
  <div class="my-card">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-start">
      <b-col
        md="2"
        class="pl-0"
      >
        <b-form-group>
          <label>Date :</label>
          <flat-pickr
            v-model="dateRange"
            :config="{ mode: 'range', enableTime: false, dateFormat: 'Y-m-d'}"
            placeholder="Filter Tanggal"
            class="form-control bg-white"
            @on-change="onDateChange"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="2"
      >
        <b-form-group>
          <label>Kategori :</label>
          <v-select
            id="category_id"
            v-model="category_id"
            :options="categoriesOpt"
            style="background-color:white;"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            placeholder="Pilih Kategori"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="2"
      >
        <b-form-group>
          <label class="mr-1">Search :</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="2"
        class="d-flex align-items-end"
      >
        <b-button
          variant="primary"
          class="mb-1"
          @click="handlePrintKategori()"
        >
          <feather-icon
            icon="PrinterIcon"
            class="mr-50"
          />
          Cetak SPK
        </b-button>
        <PrintSpk
          ref="spk"
          class="d-none"
          :data="pdata"
        />
      </b-col>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      class="custom-table"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                @click="handleProduction(props.row['prod_code'], props.row['id'])"
              >
                <feather-icon
                  icon="NavigationIcon"
                  class="mr-50"
                />
                <span v-if="props.row['prod_code'] == '1'">Mulai Pengerjaan</span>
                <span v-else-if="props.row['prod_code'] == '2'">Selesai Pengerjaan</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'prod_status'">
          <b-badge
            pill
            :variant="prodVariant[props.row['prod_code']]"
          >
            {{ props.row['prod_status'] }}
          </b-badge>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BCol, BFormInput, BFormSelect, BDropdown, BDropdownItem, BBadge, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'
import VSelect from 'vue-select'
import PrintSpk from '@/views/feature/PrintWorkshopByCategory.vue'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BCol,
    PrintSpk,
    BDropdown,
    BDropdownItem,
    BBadge,
    flatPickr,
    VSelect,
    BButton,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      showPaymentModal: false,
      columns: [
        { field: 'trx_no', label: 'No Transaksi' },
        { field: 'trx_date', label: 'Tanggal' },
        { field: 'product', label: 'Produk' },
        { field: 'category', label: 'Kategori' },
        { field: 'size', label: 'P X L' },
        { field: 'prod_status', label: 'Status' },
        { field: 'desc', label: 'Catatan' },
        { field: 'action', label: 'Action' },
      ],
      rows: [],
      searchTerm: '',
      activeId: null,
      prodStatus: {
        1: 'BELUM DIKERJAKAN',
        2: 'DALAM PENGERJAAN',
        3: 'SELESAI',
      },
      prodVariant: {
        1: 'danger',
        2: 'warning',
        3: 'success',
      },
      categoriesOpt: [],
      serverParams: {
        page: 1,
        perPage: 10,
        search: '',
        sort: {
          field: null,
          type: null,
        },
        filters: {
        },
      },
      dateRange: null,
      category_id: null,
      pdata: {
        ctg: 'GABUNGAN',
        list: [],
      },

    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    category_id(newVal) {
      if (!newVal) {
        delete this.serverParams.filters.category
        this.getOrderData()
      } else {
        this.setCategory()
      }
    },
  },
  created() {
    this.getOrderData()

    this.$http.get('/category')
      .then(res => {
        this.categoriesOpt = res.data.category.map(category => ({
          value: category.id,
          title: category.name,
        }))
      })
  },
  methods: {
    getOrderData() {
      this.$http.get('/cashier/workshop', {
        params: {
          ...this.serverParams.filters,
          ...this.serverParams.date,
        },
      })
        .then(res => {
          this.rows = [] // reset data rows sebelum push ulang
          res.data.forEach(so => {
            so.details.forEach(detail => {
              this.rows.push({
                id: detail.id,
                trx_no: so.trx_no,
                trx_date: so.trx_date,
                product: detail.product?.name || '-', // amanin kalau product null
                category: detail.product?.category.name,
                desc: detail.desc,
                file: detail.file,
                description: detail.desc,
                finishing: detail.finishing,
                qty: detail.qty,
                size: `${detail.p} X ${detail.l}`,
                prod_code: detail.prod_id ? detail.prod_id : '1',
                prod_status: this.prodStatus[detail.prod_id ? detail.prod_id : '1'],
              })
            })
          })
          this.pdata.list = this.rows
          this.pdata.ctg = this.category_id ? this.category_id.title : 'GABUNGAN'
        })
    },
    formatDateLocal(d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    onDateChange(selectedDates) {
      if (selectedDates.length === 2) {
        const filters = {
          trx_date_from: this.formatDateLocal(selectedDates[0]),
          trx_date_to: this.formatDateLocal(selectedDates[1]),
        }
        this.serverParams.date = { ...filters }
      } else {
        this.serverParams.date = {}
      }

      this.getOrderData()
    },
    setCategory() {
      const filters = {
        category: this.category_id.value,
      }
      this.serverParams.filters = { ...filters }

      this.getOrderData()
    },
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    handleProduction(status, id) {
      if (status === 2) {
        this.confirmButtonColor(id)
      } else if (status === 1 || status === '1') {
        this.$http.put(`/cashier/workshop/status/${id}`, { status: '2' }).then(() => this.$swal({
          icon: 'success',
          title: 'Barang Dalam Pengerjaan!',
          text: 'Status Produksi diperbarui menjadi Dikerjakan',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        }).then(() => {
          this.getOrderData()
        }))
      } else {
        this.$bvToast.toast('Produksi Telah Selesai!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    handlePrintKategori() {
      this.$refs.spk.print()
    },
    confirmButtonColor(id) {
      this.$swal({
        title: 'Apakah Anda yakin untuk selesaikan produksi?',
        text: 'Anda tidak bisa merubah kembali status ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proses Produksi Selesai',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.put(`/cashier/workshop/status/${id}`, { status: '3' }).then(() => this.$swal({
            icon: 'success',
            title: 'Produksi Selesai!',
            text: 'Status Produksi diperbarui menjadi Selesai',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          }).then(() => {
            this.getOrderData()
          }))
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Aksi Dibatalkan',
            text: 'Status Produksi tidak diperbarui',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.custom-table .vgt-table th {
  text-align: center;
  vertical-align: middle;
}

.custom-table .vgt-table td {
  font-size: smaller;
}
</style>
